var chunkMapping = {
	"13": [
		3013
	],
	"15": [
		75015
	],
	"134": [
		97134
	],
	"149": [
		84149
	],
	"241": [
		56241
	],
	"257": [
		85257
	],
	"318": [
		76318
	],
	"349": [
		47349
	],
	"365": [
		29365
	],
	"433": [
		1814
	],
	"608": [
		89227
	],
	"671": [
		45671
	],
	"693": [
		78693
	],
	"713": [
		83713
	],
	"861": [
		97861
	],
	"864": [
		34864
	],
	"880": [
		39880
	],
	"888": [
		56888
	],
	"932": [
		13932
	],
	"940": [
		96940
	]
};
var idToExternalAndNameMapping = {
	"1814": [
		"default",
		"./useGetPaymentsNavLinks",
		58024
	],
	"3013": [
		"default",
		"./PlayerWithdrawalsBlock",
		58024
	],
	"13932": [
		"default",
		"./PlayerSportsBetActionsBlock",
		54776
	],
	"29365": [
		"default",
		"./useGetPartnersNavLinks",
		27744
	],
	"34864": [
		"default",
		"./RouteConfigs",
		24780
	],
	"39880": [
		"default",
		"./useGetGamesNavLink",
		81720
	],
	"45671": [
		"default",
		"./RouteConfigs",
		81720
	],
	"47349": [
		"default",
		"./RoutedPage",
		58024
	],
	"56241": [
		"default",
		"./useGetSportsNavLinks",
		54776
	],
	"56888": [
		"default",
		"./AffiliateSelectors",
		27744
	],
	"75015": [
		"default",
		"./useGetActionLogNavLinks",
		24780
	],
	"76318": [
		"default",
		"./PlayerGameActionsBlock",
		81720
	],
	"78693": [
		"default",
		"./RoutedPage",
		27744
	],
	"83713": [
		"default",
		"./RouteConfigs",
		54776
	],
	"84149": [
		"default",
		"./RouteConfigs",
		58024
	],
	"85257": [
		"default",
		"./RoutedPage",
		54776
	],
	"89227": [
		"default",
		"./RoutedPage",
		81720
	],
	"96940": [
		"default",
		"./RoutedPage",
		24780
	],
	"97134": [
		"default",
		"./PlayerDepositsBlock",
		58024
	],
	"97861": [
		"default",
		"./RouteConfigs",
		27744
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}